// id of the HQ ("Zentrale", location flag isHeadquarter), replaces REACT_APP_LOCATION_HAMBURG_ID;
// set at login from /users/me (headquarterLocationId), see Modules/api/authv3.js
let headquarterLocationId = null;

export const setHeadquarterLocationId = (id) => {
    headquarterLocationId = id;
};

export const getHeadquarterLocationId = () => headquarterLocationId;

/**
 * @deprecated
 * @param locationId
 * @returns {boolean}
 */
export const isExternalLocationId = (locationId) => locationId !== getHeadquarterLocationId();

/**
 * @deprecated
 * @param employee
 * @returns {boolean}
 */
export const isExternal = (employee) => isExternalLocationId(employee.locationId);
